module.exports = __webpack_public_path__ + "static/media/tcs_logo.29690743.svg";